import { Card, Icon, Number, Space, Text } from "components/common"
import Flex from "components/common/flex"
import { Link } from "react-router-dom"
import TextSeparator from "../../../../../../components/custom/textSeparator"

const InsightInfoCard = ({ item, cardProps, iconProps, numberProps }) => {
  return (
    <Card className="hideShadow" {...cardProps}>
      <Space direction="horizontal" size={16}>
        <Icon
          icon={item?.icon}
          color={item?.color}
          size="28px"
          hasBackground
          iconContainerStyle={{ "--icon-bg-color": item?.bgColor }}
          {...iconProps}
        />
        <Space direction="vertical" size={0}>
          <Text type="secondary" className="fw-medium">
            {item?.title}
          </Text>
          <Flex align="center" gap="2px">
            <Text className="bold" {...numberProps}>
              <Number
                value={item?.value}
                isCurrency={item?.isCurrency}
                suffix={item?.suffix}
                wrapValue={item?.wrapValue}
                defaultValue={item?.value}
                tooltip
                tooltipPlacement="bottom"
                className="bold"
                style={{ fontSize: 20 }}
                {...numberProps}
              />
            </Text>
            {item?.text && <Text type="secondary">{item?.text}</Text>}
            {item?.redirectPath && (
              <Link to={item?.redirectPath} target="_blank" rel="noopener noreferrer" className="d-flex">
                <Icon icon={"FiArrowUpRight"} size={22} color={"#0091BA"} />
              </Link>
            )}
            {item?.secondaryItems?.map(e => (
              <>
                <TextSeparator />
                <Text className="bold" {...numberProps}>
                  <Number
                    value={e?.value}
                    isCurrency={e?.isCurrency}
                    suffix={e?.suffix}
                    wrapValue={e?.wrapValue}
                    defaultValue={item?.value}
                    tooltip
                    tooltipPlacement="bottom"
                    className="bold"
                    style={{ fontSize: 20 }}
                    {...numberProps}
                  />
                </Text>
                {e?.text && <Text type="secondary">{e?.text}</Text>}
                {e?.redirectPath && (
                  <Link to={e?.redirectPath} target="_blank" rel="noopener noreferrer" className="d-flex">
                    <Icon icon={"FiArrowUpRight"} size={22} color={"#0091BA"} />
                  </Link>
                )}
              </>
            ))}
          </Flex>
        </Space>
      </Space>
    </Card>
  )
}

export default InsightInfoCard
